import { getEditorSubType } from '../../../../utils';
import {
  BUILDER_TYPE,
  COMPONENT_CHANGE_EVENT_ID,
  COMPONENT_CHANGE_SRC,
  PANEL_BUILDER,
  PANEL_TYPE,
  PRODUCT_NAME,
} from './constants';

export const getBaseParams = () => ({
  product: PRODUCT_NAME,
  target_type: PRODUCT_NAME,
  editor_type: getEditorSubType(),
});

export const getBaseComponentChangeLogParams = () => ({
  ...getBaseParams(),
  panel_type: PANEL_TYPE,
  src: COMPONENT_CHANGE_SRC,
  evid: COMPONENT_CHANGE_EVENT_ID,
  builderType: BUILDER_TYPE,
  panel_builder: PANEL_BUILDER,
});
